"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _draftJs = require("draft-js");

var _adjustBlockDepthForContentState = _interopRequireDefault(require("draft-js/lib/adjustBlockDepthForContentState"));

var adjustBlockDepth = function adjustBlockDepth(editorState, adjustment, maxDepth) {
  var content = (0, _adjustBlockDepthForContentState["default"])(editorState.getCurrentContent(), editorState.getSelection(), adjustment, maxDepth);
  return _draftJs.EditorState.push(editorState, content, 'adjust-depth');
};

var _default = adjustBlockDepth;
exports["default"] = _default;